import React from 'react';
import {
  Box,
  FormControlLabel,
  Checkbox,
  TextField,
} from '@mui/material';

const PhaseEventBehaviorSections = ({
  dataPoint,
  index,
  handleCheckboxChange,
  handleFieldChange,
}) => {
  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={dataPoint.selectedOptions.includes(
              'Add Phase Change Line'
            )}
            onChange={(e) => handleCheckboxChange(index, e)}
            value='Add Phase Change Line'
          />
        }
        label='Add Phase Change Line'
      />
      {dataPoint.selectedOptions.includes('Add Phase Change Line') && (
        <Box sx={{ ml: 3, pl: 2, borderLeft: '2px solid #e0e0e0' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <TextField
              fullWidth
              margin='dense'
              value={dataPoint.phaseChange}
              className='input-height'
              onChange={(e) =>
                handleFieldChange(index, 'phaseChange', e.target.value)
              }
            />
          </Box>
        </Box>
      )}

      <FormControlLabel
        control={
          <Checkbox
            checked={dataPoint.selectedOptions.includes('Add Event Line')}
            onChange={(e) => handleCheckboxChange(index, e)}
            value='Add Event Line'
          />
        }
        label='Add Event Line'
      />
      {dataPoint.selectedOptions.includes('Add Event Line') && (
        <Box sx={{ ml: 3, pl: 2, borderLeft: '2px solid #e0e0e0' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <TextField
              fullWidth
              margin='dense'
              value={dataPoint.eventLine}
              className='input-height'
              onChange={(e) =>
                handleFieldChange(index, 'eventLine', e.target.value)
              }
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default PhaseEventBehaviorSections;
